import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    loader: false,
    unitMesurementdetails: '',
    unitClassdetails: '',
    unitConversiondetails: '',
    productUnitConversiondetails: '',
    productUnitConversionLoader: '',
    productGroupDetails: '',
    productGroupLoader: '',
    locationDetails: '',
    locationLoader: '',
    maintainPriceDetails: '',
    maintainPriceError: '',
    maintainPriceLoader: '',
    purchasePriceDetails: '',
    purchasePriceError: '',
    purchasePriceLoader: '',
    salesDiscountDetails: '',
    salesDiscountError: '',
    salesDiscountLoader: '',
    error: '',

};

export default function productSetupReducer(state = initState, action) {
    switch (action.type) {
        case actions.UNITMESUREMENT_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.UNITMESUREMENT_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                unitMesurementdetails: action.payload,
            };
        }
        case actions.UNITMESUREMENT_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }


        case actions.MAINTAIN_PRICE_DETAILS_START: {
            return {
                ...state,
                maintainPriceLoader: true,
            };
        }
        case actions.MAINTAIN_PRICE_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension, action.exportType);
            }
            return {
                ...state,
                maintainPriceLoader: false,
                maintainPriceDetails: action.payload,
            };
        }
        case actions.MAINTAIN_PRICE_DETAILS_FAILURE: {
            return {
                ...state,
                maintainPriceLoader: false,
                maintainPriceError: action.message,
            };
        }


        case actions.SALES_DISCOUNT_DETAILS_START: {
            return {
                ...state,
                salesDiscountLoader: true,
            };
        }
        case actions.SALES_DISCOUNT_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension, action.exportType);
            }
            return {
                ...state,
                salesDiscountLoader: false,
                salesDiscountDetails: action.payload,
            };
        }
        case actions.SALES_DISCOUNT_DETAILS_FAILURE: {
            return {
                ...state,
                salesDiscountLoader: false,
                salesDiscountError: action.message,
            };
        }

        case actions.PURCHASE_PRICE_DETAILS_START: {
            return {
                ...state,
                purchasePriceLoader: true,
            };
        }
        case actions.PURCHASE_PRICE_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension, action.exportType);
            }
            return {
                ...state,
                purchasePriceLoader: false,
                purchasePriceDetails: action.payload,
            };
        }
        case actions.PURCHASE_PRICE_DETAILS_FAILURE: {
            return {
                ...state,
                purchasePriceLoader: false,
                purchasePriceError: action.message,
            };
        }

        case actions.UNITCLASS_DETAILS_START: {
            return {
                ...state,
                loader: true
            };
        }
        case actions.UNITCLASS_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                unitClassdetails: action.payload
            };
        }
        case actions.UNITCLASS_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }

        case actions.UNITCONVERSION_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.UNITCONVERSION_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                unitConversiondetails: action.payload,
            };
        }
        case actions.UNITCONVERSION_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }

        case actions.PRODUCT_UNITCONVERSION_DETAILS_START: {
            return {
                ...state,
                productUnitConversionLoader: true,
            };
        }
        case actions.PRODUCT_UNITCONVERSION_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                productUnitConversionLoader: false,
                productUnitConversiondetails: action.payload,
            };
        }
        case actions.PRODUCT_UNITCONVERSION_DETAILS_FAILURE: {
            return {
                ...state,
                productUnitConversionLoader: false,
                error: action.message,
            };
        }


        case actions.PRODUCT_GROUP_DETAILS_START: {
            return {
                ...state,
                productGroupLoader: true,
            };
        }
        case actions.PRODUCT_GROUP_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                productGroupLoader: false,
                productGroupDetails: action.payload,
            };
        }
        case actions.PRODUCT_GROUP_DETAILS_FAILURE: {
            return {
                ...state,
                productGroupLoader: false,
                error: action.message,
            };
        }

        case actions.LOCATION_DETAILS_START: {
            return {
                ...state,
                locationLoader: true,
            };
        }
        case actions.LOCATION_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                locationLoader: false,
                locationDetails: action.payload,
            };
        }
        case actions.LOCATION_DETAILS_FAILURE: {
            return {
                ...state,
                locationLoader: false,
                error: action.message,
            };
        }

        case actions.CLEAR_ADDRESS_DETAILS_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_ADDRESS_DETAILS_SUCCESS: {
            return {
                ...state,
                loader: true
            };
        }
        default:
            return state;
    }
}